import { simpleSet } from '@r/reducers/utils';

export const projectId = simpleSet(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_ID',
  ''
);
